<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="showSearch()">选择配件</el-button>
                <el-button size="small" icon="el-icon-upload" class="search-btn btn-primary" @click="handleImport" :readonly="saveLoading"
                    >上传到联盟产品库<span v-if="dataList.length">（{{ dataList.length }}）</span></el-button
                >
                <div class="explain">（ * 提交的数据中，各价格段都需要进行设置，避免在分配价格段给对应的联盟成员时，展示为 0 。）</div>
            </div>
        </div>
        <div class="search-ctn" style="min-height: 30px; padding-top: 0; margin-top: -5px" v-if="dataList.length">
            <div class="search-ctn-right">
                <div class="search-name" style="margin-bottom: 5px">
                    <el-tooltip effect="dark" placement="bottom">
                        <div slot="content">可以选择目前商品已有的价格段赋值到联盟的价格段。</div>
                        <span>
                            <i class="el-icon-warning-outline"></i>
                        </span> </el-tooltip
                    >价格段赋值
                </div>
                <div v-for="(item, index) in levelList" :key="item.LevelId" class="pricelevel">
                    <div class="search-name" style="margin-bottom: 5px">
                        {{ item.LevelName }}
                    </div>
                    <div class="select-item" style="margin-bottom: 5px">
                        <el-select size="small" style="width: 120px" v-model="item.PriceLevel" @change="selectedChange" clearable @clear="clearSelected(index + '_0')">
                            <el-option label="成本价" :value="index + '_1'"></el-option>
                            <el-option label="批发价" :value="index + '_2'"></el-option>
                            <el-option label="零售价" :value="index + '_3'"></el-option>
                        </el-select>
                        <el-input
                            type="number"
                            step="0.1"
                            min="0.0"
                            size="small"
                            style="width: 60px"
                            v-model.trim="item.PricePoint"
                            @change="pointChange(item.PricePoint, item.PriceLevel)"
                        ></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="union-import-goods">
            <ux-grid ref="plxTable" :max-height="630" show-overflow show-header-overflow="ellipsis" :data="dataList" v-if="levelList.length > 0">
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column title="汽配编码" show-overflow-tooltip min-width="100px" field="APCode"> </ux-table-column>
                <ux-table-column title="汽配名称" show-overflow-tooltip min-width="100px" field="GoodName"></ux-table-column>
                <ux-table-column title="适用车型" show-overflow-tooltip min-width="100px" field="AutoSerise"> </ux-table-column>
                <ux-table-column title="汽配分类" show-overflow-tooltip width="100px" field="Cate"> </ux-table-column>
                <ux-table-column title="品牌" show-overflow-tooltip width="100px" field="Brand"> </ux-table-column>
                <ux-table-column title="成本价" show-overflow-tooltip width="90px" field="CostPrice" v-if="inventCantEdit"></ux-table-column>
                <ux-table-column title="批发价" show-overflow-tooltip width="90px" field="Price" v-if="inventCantEdit"></ux-table-column>
                <ux-table-column title="零售价" show-overflow-tooltip width="90px" field="MarketPrice" v-if="inventCantEdit"></ux-table-column>
                <ux-table-column title="库存数" show-overflow-tooltip width="90px" field="Inventory" v-if="inventCantEdit"> </ux-table-column>
                <ux-table-column title="可售数" show-overflow-tooltip width="100px" field="Inventory" v-if="!inventCantEdit">
                    <template slot-scope="scope">
                        <el-input type="number" size="small" v-model="scope.row.Inventory"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column title="价格段价格设置">
                    <ux-table-column v-for="(item, index) in levelList" :key="item.LevelId" :title="item.LevelName" width="130px">
                        <template slot-scope="scope">
                            <el-input-number
                                type="number"
                                size="small"
                                :min="0"
                                controls-position="right"
                                style="width: 118px"
                                v-model="scope.row[`LevelPrice_${index}`]"
                            ></el-input-number>
                        </template>
                    </ux-table-column>
                </ux-table-column>
            </ux-grid>
        </div>
        <el-dialog :close-on-click-modal="false" title="搜索配件并选择上传至联盟" :visible.sync="searchVisible" width="1248px">
            <div v-if="searchVisible">
                <searchAP :SelectedData="selectedData" @chooseAllAPsHandle="chooseAllAPsHandle" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import searchAP from '@/components/entpUnion/goodsManage/searchAPForUnion';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        searchAP
    },
    data() {
        return {
            unionId: this.$util.getLocalStorage('currentUnion'),
            saveLoading: false,
            selectedData: [],
            inventCantEdit: false,
            dataList: [],
            searchVisible: false,
            levelList: [],
            selectedLimit: [],
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            newDataList: []
        };
    },
    created() {
        this.getLevelData();
    },
    mounted() {
        this.getEditInventValue();
    },
    methods: {
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpUnionGoods/GetGoodsListForUnion',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        // 搜索配件弹框 - 关闭弹框并更新页面数据
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                if (this.dataList.length > 0)
                    that.dataList.forEach((e, index) => {
                        if (item.APCode == e.APCode) {
                            isExist = true;
                        }
                    });
                if (!isExist) {
                    let newGoods = {
                        Price: item.Price,
                        CostPrice: item.CostPrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        Cate: item.Cate,
                        Brand: item.Brand,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        Count: 0,
                        MarketPrice: item.MarketPrice,
                        Unit: item.Unit,
                        Remark: '',
                        Inventory: item.Inventory,
                        State: 0
                    };
                    newGoodsList.push(newGoods);
                }
            }

            if (newGoodsList.length > 0) {
                newGoodsList.forEach(item => {
                    for (let j = 0; j < that.levelList.length; j++) {
                        let l = that.levelList[j];
                        if (l.PriceType > 0 && l.PricePoint != 0 && l.PricePoint != 1) {
                            switch (l.PriceType) {
                                case 0:
                                    item[`LevelPrice_${j}`] = 0;
                                    break;
                                case 1:
                                    item[`LevelPrice_${j}`] = (item.CostPrice * l.PricePoint).toFixed(2);
                                    break;
                                case 2:
                                    item[`LevelPrice_${j}`] = (item.Price * l.PricePoint).toFixed(2);
                                    break;
                                case 3:
                                    item[`LevelPrice_${j}`] = (item.MarketPrice * l.PricePoint).toFixed(2);
                                    break;
                            }
                        } else item[`LevelPrice_${j}`] = 0;
                    }
                });
            }

            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.searchVisible = false;
        },
        handleImport() {
            let that = this;
            that.saveLoading = true;
            let newDataList = [];
            that.dataList.forEach(item => {
                let newData = {
                    GoodsId: '',
                    Count: 0,
                    PriceLevels: []
                };
                for (let index = 0; index < that.levelList.length; index++) {
                    newData.PriceLevels.push(item[`LevelPrice_${index}`]);
                }
                newData.GoodsId = item.EntpTempGoodsId;
                newData.Count = item.Inventory;
                newDataList.push(newData);
            });

            that.newDataList = newDataList;

            that.loopImport();
        },
        loopImport() {
            let that = this;
            let newDataList = that.newDataList;
            //每次取100条数据
            let apList = [];
            let start = (that.currtPage - 1) * 100;
            if (start >= newDataList.length) start = 0;
            let end = that.currtPage * 100;
            if (end >= newDataList.length) end = newDataList.length;
            apList = newDataList.slice(start, end);

            that.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/SubmitUnionGoods',
                    data: {
                        UnionId: that.unionId,
                        GoodsList: apList
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.saveCount += apList.length;
                        let num = parseFloat(that.saveCount);
                        let total = parseFloat(newDataList.length);
                        that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                        that.percentage = that.percentage > 100 ? 100 : that.percentage;

                        if (newDataList.length <= that.saveCount) {
                            setTimeout(function () {
                                that.saveLoading = false;
                                that.percentage = 0;
                                that.currtPage = 1;
                                that.dataList = [];
                                that.newDataList = [];
                            }, 1000);
                        } else {
                            that.currtPage++;
                            that.loopImport();
                        }
                    }
                })
                .catch(() => {
                    that.saveLoading = false;
                });
        },
        getLevelData() {
            let that = this;
            that.loading = true;
            return new Promise((resolve, reject) => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpUnionGoods/GetUnionPriceLevelList',
                        data: { UnionId: this.unionId },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        let index = 0;
                        data.forEach(item => {
                            item.PricePoint = item.PricePoint != 1 && item.PricePoint != 0 ? item.PricePoint : (1.0).toFixed(1);
                            if (item.PriceType != 0) item.PriceLevel = index + '_' + item.PriceType;
                            that.levelList.push(item);
                            index++;
                        });
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            });
        },
        selectedChange(event) {
            let that = this;
            if (event) {
                let arr = event.split('_');
                if (arr.length == 2) {
                    let index = Number(arr[0]);
                    let priceL = Number(arr[1]);
                    let level = that.levelList[index];
                    let newDataList = [];
                    if (level) {
                        let pricePoint = Number(level.PricePoint);
                        that.dataList.forEach(item => {
                            switch (priceL) {
                                case 0:
                                    item[`LevelPrice_${index}`] = 0;
                                    break;
                                case 1:
                                    item[`LevelPrice_${index}`] = (item.CostPrice * pricePoint).toFixed(2);
                                    break;
                                case 2:
                                    item[`LevelPrice_${index}`] = (item.Price * pricePoint).toFixed(2);
                                    break;
                                case 3:
                                    item[`LevelPrice_${index}`] = (item.MarketPrice* pricePoint).toFixed(2);
                                    break;
                            }
                            newDataList.push(item);
                        });
                        if (newDataList.length > 0) that.dataList = newDataList;
                    }
                }
            }
        },
        clearSelected(event) {
            if (event) {
                this.selectedChange(event);
            }
        },
        getEditInventValue() {
            this.$util.getUnionConfig('tbqykc').then(res => {
                this.inventCantEdit = res.Result;
            });
        },
        pointChange(point, pLevel) {
            let that = this;
            if (pLevel) {
                let arr = pLevel.split('_');
                if (arr.length == 2) {
                    let index = Number(arr[0]);
                    let priceL = Number(arr[1]);
                    let level = that.levelList[index];
                    let newDataList = [];
                    if (level) {
                        let pricePoint = Number(point);
                        that.dataList.forEach(item => {
                            switch (priceL) {
                                case 0:
                                    item[`LevelPrice_${index}`] = 0;
                                    break;
                                case 1:
                                    item[`LevelPrice_${index}`] = (item.CostPrice * pricePoint).toFixed(2);
                                    break;
                                case 2:
                                    item[`LevelPrice_${index}`] = (item.Price * pricePoint).toFixed(2);
                                    break;
                                case 3:
                                    item[`LevelPrice_${index}`] = (item.MarketPrice * pricePoint).toFixed(2);
                                    break;
                            }
                            newDataList.push(item);
                        });
                        if (newDataList.length > 0) that.dataList = newDataList;
                    }
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-btn {
    margin-left: 0;
    margin-right: 20px;
}
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
.pricelevel {
    display: flex;
    flex-direction: row;
}
</style>
<style lang="less">
.union-import-goods {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 36px;
                    line-height: 36px;
                }
            }

            .elx-cell {
                height: 36px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}
</style>
